export const validation = {
  note: 'Note is required',
  noteMax: 'Note must be less than 250 character',
};
